var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12 22.007c.552 0 1 .448 1 1s-.448 1-1 1H1c-.552 0-1-.448-1-1s.448-1 1-1zm-2-5c.828 0 1.5.672 1.5 1.5v1.5c0 .552-.448 1-1 1h-8c-.552 0-1-.448-1-1v-1.5c0-.828.672-1.5 1.5-1.5zM13.995.367c.598-.518 1.494-.484 2.05.079l4.681 4.681c.557.556.589 1.448.074 2.043-.516.595-1.403.69-2.033.219-.1-.075-.239-.065-.327.023l-1.763 1.764c-.048.048-.075.115-.073.183.002.068.031.133.082.179l6.814 6.133c.317.306.496.727.496 1.168 0 .44-.179.862-.496 1.168-.306.316-.727.494-1.166.494-.44 0-.861-.178-1.167-.494l-6.135-6.814c-.046-.051-.11-.081-.18-.083-.068-.002-.134.024-.183.073l-1.763 1.764c-.088.087-.098.227-.024.326.472.63.376 1.517-.219 2.033-.595.515-1.487.483-2.043-.074l-4.681-4.681c-.553-.557-.584-1.446-.07-2.04.515-.593 1.399-.69 2.029-.221.1.074.239.064.327-.024l5.535-5.533c.088-.088.098-.227.023-.326-.478-.63-.385-1.522.212-2.04z",
    transform: "translate(-1392 -258) translate(240 252) translate(1152 6)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBid);
export default __webpack_public_path__ + "static/media/bid.bd5f2865bd8f7a5018c30dd4c01d06be.svg";
export { ForwardRef as ReactComponent };